import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { Global } from 'src/app/global';
import { ApiService } from 'src/app/service/apiServices';
import { AuthService } from 'src/app/service/auth/auth.service';
declare var jquery: any;
declare var $: any;
declare var FullCalendar: any;
import Swal from 'sweetalert2';
import * as moment from "moment";
@Component({
  selector: 'app-ficha-faturamento',
  templateUrl: './ficha-faturamento.component.html',
  styleUrls: ['./ficha-faturamento.component.css']
})
export class FichaFaturamentoComponent implements OnInit {
  usuario: any = {};
  presenca: any = {};
  loading: any = false;
  ficha: any = {};
  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private alerts: NgxAlertsService,
    private router: Router,
    private global: Global,
    private authService: AuthService
  ) {
    this.authService.currentUser.subscribe(res => {
      if (res) {
        this.usuario = res;
      }
    });
    this.authService.currentPresenca.subscribe(res => {
      if (res) {
        this.presenca = res;
      }
    });
  }

  ngOnInit() {
  }

  limparFilto() {
    this.ficha = {};
  }


  gerarFicha() {
    const parseDate = (str: string): Date | null => {
      if (!str) return null;
      const parts = str.split('/');
      if (parts.length !== 3) return null;

      const [dia, mes, ano] = parts.map(p => parseInt(p, 10));
      const date = new Date(ano, mes - 1, dia);
      return isNaN(date.getTime()) ? null : date;
    };

    // Validação das datas de busca (se ambas forem preenchidas)
    let buscaInicio: any = parseDate(this.ficha.busca_data_inicio);
    let buscaFim: any = parseDate(this.ficha.busca_data_final);

    if (!buscaInicio || !buscaFim) {
      Swal.fire('Erro', 'As datas de inicio e fim são inválidas.', 'error');
      return;
    }

    if (this.ficha.busca_data_inicio && this.ficha.busca_data_final) {
      if (!buscaInicio || !buscaFim) {
        Swal.fire('Erro', 'As datas de busca são inválidas.', 'error');
        return;
      }

      if (buscaInicio > buscaFim) {
        Swal.fire('Erro', 'A data de início da busca não pode ser maior que a data final.', 'error');
        return;
      }
    }

    const alterarInicio = parseDate(this.ficha.alterar_data_inicio);
    const alterarFim = parseDate(this.ficha.alterar_data_final);

    if (!alterarInicio || !alterarFim) {
      Swal.fire('Erro', 'As datas de alteração são inválidas.', 'error');
      return;
    }

    if (alterarInicio > alterarFim) {
      Swal.fire('Erro', 'A data de início de alteração não pode ser maior que a data final.', 'error');
      return;
    }

    if (!this.ficha.lote) {
      Swal.fire('Erro', 'O campo "Lote" é obrigatório.', 'error');
      return;
    }



    const json = {
      busca_data_inicio: buscaInicio ? buscaInicio.toISOString() : null,
      busca_data_final: buscaFim ? buscaFim.toISOString() : null,
      busca_ine: this.ficha.busca_ine || '',
      alterar_data_inicio: alterarInicio.toISOString(),
      alterar_data_final: alterarFim.toISOString(),
      alterar_cns_profissional: this.ficha.alterar_cns_profissional || '',
      lote: Number(this.ficha.lote)
    };

    console.log('JSON montado:', json);
    this.gerarFichaFatamento(json)
    // Enviar para a API se necessário
    // this.seuServico.enviarFicha(json).subscribe(...)
  }

  gerarFichaFatamento = (obj) => {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.service.Post(`FichaFaturamentoAps/CadastroIndividual`, obj).then((res: any) => {
      this.loading = false;
      const url = res.url || res; // caso o retorno seja o link diretamente ou dentro de um campo 'url'      
      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.download = ''; // o browser usará o nome do arquivo da URL
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        this.alerts.notifyError({
          body: 'Nenhum link de download foi retornado.',
          title: 'Erro'
        });
      }

    }).catch(res => {
      this.loading = false;
      if (res.status === 200) {
        const url = res.error.text || res; // caso o retorno seja o link diretamente ou dentro de um campo 'url'        
        if (url) {
          const a = document.createElement('a');
          a.href = url;
          a.download = ''; // o browser usará o nome do arquivo da URL
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          this.alerts.notifyError({
            body: 'Nenhum link de download foi retornado.',
            title: 'Erro'
          });
        }
      } else
        if (res.status === 524) {
          this.alerts.notifyError({
            body: 'A requisição excedeu o tempo limite. Por favor, tente novamente mais tarde.',
            title: 'Tempo esgotado'
          });
        } else {
          this.alerts.notifyError({
            body: `${res.error.messagem}`,
            title: 'Erro'
          });
        }
    })
  }

}
